module.exports = __webpack_public_path__ + "img/ybms.bcfc4465.png";